export type SubscriptionHealthStatus =
  | 'ACTIVE'
  | 'TRIALING'
  | 'PAST_DUE'
  | 'CANCELED'
  | 'INCOMPLETE'
  | 'INCOMPLETE_EXPIRED'
  | 'UNPAID'
  | 'PAUSED'
  | 'UNKNOWN';

export function getSubscriptionHealthStatus(
  subscriptionStatus: string | null | undefined,
  trialEndsAt?: string | null,
  now = new Date(),
): SubscriptionHealthStatus {
  const trialEnd = trialEndsAt ? new Date(trialEndsAt) : null;
  const hasActiveTrial = !!trialEnd && !Number.isNaN(trialEnd.getTime()) && trialEnd > now;

  // A future trial date is more reliable than legacy values written before statuses were normalised.
  if (hasActiveTrial) return 'TRIALING';

  const status = subscriptionStatus
    ?.trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');

  switch (status) {
    case 'ACTIVE':
      return 'ACTIVE';
    case 'TRIAL':
    case 'TRAIL':
    case 'TRIALING':
      return trialEnd ? 'INCOMPLETE_EXPIRED' : 'TRIALING';
    case 'PAST_DUE':
      return 'PAST_DUE';
    case 'CANCELED':
    case 'CANCELLED':
      return 'CANCELED';
    case 'INCOMPLETE':
      return 'INCOMPLETE';
    case 'INCOMPLETE_EXPIRED':
      return 'INCOMPLETE_EXPIRED';
    case 'UNPAID':
      return 'UNPAID';
    case 'PAUSED':
      return 'PAUSED';
    default:
      return 'UNKNOWN';
  }
}

export function isActiveSubscription(subscriptionStatus: string | null | undefined) {
  return getSubscriptionHealthStatus(subscriptionStatus) === 'ACTIVE';
}
